import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import PdfIcon from "../../../Components/Icon-SVG/PdfIcon";
import Chart from "../../../Components/common/Chart/Chart";
import GeneralInformationCard from "../../../Components/PagesComponents/AnalysisReports/GeneralInformationCard/GeneralInformationCard";
import { loadFromLocalStorage } from "../../../utils/localStorage";
import AndroidContent from "./Content/AndroidContent";
import VideoPlayer from "../../../Components/common/VideoPlayer/VideoPlayer";
import {
  RequestAndroidAdditionalDetails,
  RequestApkInfo,
  RequestCrimes,
  RequestPermissions,
  RequestPlugins,
  RequestStaticCodeIssues,
} from "../../../store/actions/androidActions";
import {
  RequestGeneralAnalysis,
  RequestIocs,
  RequestNetwork,
  RequestScreenshots,
} from "../../../store/actions/analysisReportActions";
import Backdrop from "../../../Components/UI/Backdrop/Backdrop";
import ClamCloudMl from "../../../Components/PagesComponents/AnalysisReports/ClamCloudMlResults/ClamCloudMl";
import APKInformationCard from "../../../Components/PagesComponents/AnalysisReports/APKInformationCard/APKInformationCard";
import DownloadIcon from "../../../Components/Icon-SVG/DownloadIcon";
import DownloadMessage from "../../../Components/common/DownloadMessage/DownloadMessage";
import useDownloadSample from "../../../utils/hook/useDownloadSample";

import "./styles.scss";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const AndroidAnalysisReports = () => {
  const dispatch = useDispatch();

  const theme = loadFromLocalStorage("theme");

  const general = useSelector((state) => state.analysisReports.general);
  const loadingGeneral = useSelector((state) => state.analysisReports.loadingGeneral);

  const [fileNameHover, setFileNameHover] = useState(false);
  const [staticResultsActive, setStaticResultsActive] = useState(false);

  let query = useQuery();

  const fileHash = general?.sha1;
  const { downloadOptions, fileName, downloadSampleHandler } = useDownloadSample(fileHash);

  useEffect(() => {
    // setShowPopup(false);

    dispatch(
      RequestGeneralAnalysis({
        parentID: query.get("data"),
        clickedFileID: query.get("data"),
      }),
    );

    dispatch(
      RequestNetwork({
        parentID: query.get("data"),
        clickedFileID: query.get("data"),
      }),
    );

    dispatch(
      RequestIocs({
        parentID: query.get("data"),
        clickedFileID: query.get("data"),
      }),
    );

    dispatch(RequestScreenshots(query.get("data")));

    dispatch(RequestApkInfo(query.get("data")));
    dispatch(RequestCrimes(query.get("data")));
    dispatch(RequestStaticCodeIssues(query.get("data")));
    dispatch(RequestPermissions(query.get("data")));
    dispatch(RequestPlugins(query.get("data")));
    dispatch(RequestAndroidAdditionalDetails(query.get("data")));
  }, []);

  return (
    <div>
      {loadingGeneral ? (
        <Backdrop absolute={true} show={loadingGeneral} message="Loading report page..." />
      ) : (
        <div className="analysis-reports">
          <div className="analysis-reports__header">
            <div className="analysis-reports__header-doughnutChart">
              <Chart
                name={`doughnut-${theme}`}
                type="doughnut"
                fileState={query.get("state")}
                decision_score={general?.decision_score || "-"}
              />
            </div>
            <div className="analysis-reports__header-inner">
              <h1>
                <Link
                  className="analysis-reports__header-action"
                  title="Export report"
                  to={{
                    pathname: "/android-report-export",
                    search: `?data=${query.get("data")}&state=${query.get("state")}`,
                  }}>
                  <PdfIcon />
                </Link>
                <button
                  type="button"
                  className="analysis-reports__header-action"
                  title="Download Sample"
                  onClick={downloadSampleHandler}>
                  <DownloadIcon color="white" stroke="white" width={20} height={20} />
                </button>
                <b>|</b>
                <b
                  style={{ cursor: "default" }}
                  onMouseOver={() => setFileNameHover(false)}
                  onMouseOut={() => setFileNameHover(false)}>
                  {general &&
                    (fileNameHover
                      ? general?.file_name
                      : general?.file_name?.length > 20
                        ? `${general?.file_name?.substring(
                            0,
                            10,
                          )}..........${general?.file_name?.substring(
                            general?.file_name?.length - 6,
                          )}`
                        : general?.file_name)}
                </b>
                <span
                  className={
                    general?.isApt
                      ? "analysis-reports__header-verdict analysis-reports__header-verdict--apt"
                      : query.get("state") === "malicious"
                        ? "analysis-reports__header-verdict analysis-reports__header-verdict--malicious"
                        : query.get("state") === "not suspicious"
                          ? "analysis-reports__header-verdict analysis-reports__header-verdict--not-suspicious"
                          : "analysis-reports__header-verdict analysis-reports__header-verdict--suspicious"
                  }>
                  {general?.isApt ? <span>malicious</span> : query.get("state")}
                  {/* {general?.isApt ? <span>malicious</span> : "malicious"} */}
                </span>
              </h1>
              <p className="analysis-reports__header-explanation">
                You can generate pdf report by clicking the pdf icon.
              </p>
            </div>

            <div style={{ flex: 1, marginLeft: "20px" }}>
              <ClamCloudMl setStaticResultsActive={setStaticResultsActive} />
            </div>
          </div>
          <div className="analysis-reports__body">
            <div className="analysis-reports__body-block">
              <GeneralInformationCard
                key={general}
                fileName={general?.file_name}
                size={general?.size}
                sha1={general?.sha1}
                started={general?.analysis_started}
                reportDate={general?.report_date}
                fileID={query.get("data")}
                linkDisabled={true}
                setShowPopup={() => {}}
                displayViewRelated={false}
              />
              <APKInformationCard />
              <div className="analysis-reports__body-block__video-player">
                <VideoPlayer />
              </div>
              {/* <Screenshots /> */}
            </div>
            <AndroidContent
              staticResultsActive={staticResultsActive}
              setStaticResultsActive={setStaticResultsActive}
            />
            {/* <Content
          staticResultsActive={staticResultsActive}
          setStaticResultsActive={setStaticResultsActive}
        /> */}
          </div>
          <Backdrop
            show={downloadOptions.downloadStarted}
            message={
              <DownloadMessage
                fileName={fileName}
                loaded={downloadOptions.loaded}
                total={downloadOptions.total}
                progress={downloadOptions.progress}
              />
            }
          />
        </div>
      )}
    </div>
  );
};

export default AndroidAnalysisReports;
